(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.isHomePages = window.location.pathname === '/';
      this.isHomePages && this.header.classList.add('scrollTop__style');
      const logoList = [...document.querySelector('.header__heading-link').children];
      this.whiteLogo = logoList[0];
      this.blackLogo = logoList[1];
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrollMostTop = true;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
        this.isScrollMostTop = false;
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          this.reveal && requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 22);

          requestAnimationFrame(this.hide.bind(this));
        }
        this.isScrollMostTop = false;
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
        this.isScrollMostTop = true;
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.isHomePages ? this.switchHeaderBarStyle() : this.switchHeaderLogo();
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.isHomePages ? this.switchHeaderBarStyle() : this.switchHeaderLogo();
    }
    /** 切换header的样式 */
    switchHeaderBarStyle() {
      const isOpenAsideBar = document.querySelector('header-drawer summary').getAttribute('aria-expanded')
       || document.querySelector('cart-drawer summary').getAttribute('aria-expanded');
      if(!isOpenAsideBar && this.isScrollMostTop) {
        this.whiteLogo.classList.remove('small-hide');
        this.blackLogo.classList.add('small-hide');
        this.header.classList.add('scrollTop__style');
      } else {
        this.whiteLogo.classList.add('small-hide');
        this.blackLogo.classList.remove('small-hide');
        this.header.classList.remove('scrollTop__style');
      }
    }
    switchHeaderLogo() {
      this.whiteLogo.classList.add('small-hide');
      this.blackLogo.classList.remove('small-hide');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  if (!customElements.get('accessory-add')) {
    customElements.define('accessory-add', class AccessoryAdd extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const id = Number(this.getAttribute('id'))
        const handle = this.getAttribute('handle')
        this.querySelector('.select-item-button').addEventListener('click', () => {
          if (window.currentVariantAvailable) {
            window.UniEventBus.submit('SELECT_ACCESSORY_ITEM', {
              productId: id,
              productHandle: handle,
              variantId: window.currentVariantId,
              variantPrice: window.currentVariantPrice,
              sku: window.currentVariantSku,
            });
          }
        });
    
        window.UniEventBus.on('UPDATE_SELECTED_ACCESSORIES',  (data) => {
          if (data.map((item) => item.productId).includes(id)) {
            this.querySelector('.accessory-add-button').classList.add('selected');
            this.querySelector('.select-item-button').classList.add('selected');
          } else {
            this.querySelector('.accessory-add-button').classList.remove('selected');
            this.querySelector('.select-item-button').classList.remove('selected');
          }
        });
      }
    })
  }

  let headerRevealCache;
  // const options = {
  //   rootMargin: '0px 0px 99999px 0px',
  // };

  const productFormArea = document.querySelector('product-form');
  const observer = new IntersectionObserver(function (entries) {
    const header = document.querySelector('sticky-header');
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    const productNavEl = document.querySelector('#product_nav');
    if (header.reveal) {
      headerRevealCache = header.reveal;
    }

    if (entries[0].boundingClientRect.y < 0) {
      header.hide();
      header.reveal = null;
      productInfoWrapper.classList.add('ceiling','page-width');
      productNavEl.classList.remove('hidden');
      if(productInfoWrapper.querySelector('.discount-code-tip-wrapper')){
        productInfoWrapper.querySelector('.discount-code-tip-wrapper').style.display="none";
      }
      if(productInfoWrapper.querySelector('.collection-discount-code-tip-wrapper')){
        productInfoWrapper.querySelector('.collection-discount-code-tip-wrapper').style.display="none";
      }
      if(productInfoWrapper.querySelector('.BF-product-countdown-wrapper')){
        productInfoWrapper.querySelector('.BF-product-countdown-wrapper').style.display="none";
      }
      // productFormArea.classList.add('fixed-bottom');
    } else {
      header.reveal = headerRevealCache;
      header.reveal();
      productInfoWrapper.classList.remove('ceiling', 'page-width');
      productNavEl.classList.add('hidden');
      if(productInfoWrapper.querySelector('.discount-code-tip-wrapper')){
        productInfoWrapper.querySelector('.discount-code-tip-wrapper').style.display="block";
      }
      if(productInfoWrapper.querySelector('.collection-discount-code-tip-wrapper')){
        productInfoWrapper.querySelector('.collection-discount-code-tip-wrapper').style.display="block";
      }
      if(productInfoWrapper.querySelector('.BF-product-countdown-wrapper')){
        productInfoWrapper.querySelector('.BF-product-countdown-wrapper').style.display="block";
      }
      // productFormArea.classList.remove('fixed-bottom');
    }
  });

  if (window.innerWidth > 750) {
    observer.observe(document.querySelector('.fixed_position'));
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth > 750) {
      observer.observe(document.querySelector('.fixed_position'));
    } else {
      observer.unobserve(document.querySelector('.fixed_position'));
    }
  });
  // observer.observe(document.querySelector('.fixed_position'));

  ondeviceorientation = (event) => {
  };

  // 商详悬浮顶部导航栏
  document.addEventListener('DOMContentLoaded', function() {
  const navLinks = document.querySelectorAll('.fixed-tabs__links-item');
  
  const observerOptions = {
    root: null,
    rootMargin: '-20% 0px -79% 0px', // 调整可见区域的范围
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const id = entry.target.getAttribute('id');
      const link = document.querySelector(`.fixed-tabs__links-item[data-section-id="${id}"]`);
      
      if (entry.isIntersecting) {
        // 移除所有链接的active类
        navLinks.forEach(link => link.classList.remove('active'));
        // 给当前可见区域对应的链接添加active类
        link?.classList.add('active');
      } else {
        link?.classList.remove('active');
      }
    });
  }, observerOptions);

  // 观察所有内容区域
  navLinks.forEach(link => {
    const sectionId = link.getAttribute('data-section-id');
    const section = document.getElementById(sectionId);
    if (section) {
      observer.observe(section);
    }
  });

  // 点击导航链接时平滑滚动
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const sectionId = link.getAttribute('data-section-id');
      document.getElementById(sectionId)?.scrollIntoView({ 
        behavior: 'smooth' 
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
